function toFiniteNumber(value) {
  if (value === null || value === undefined || value === '') {
    return null;
  }
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : null;
}

function buildCandidate({ timeStamp, price }) {
  const normalizedTimeStamp = toFiniteNumber(timeStamp);
  const normalizedPrice = toFiniteNumber(price);

  if (normalizedTimeStamp === null || normalizedPrice === null) {
    return null;
  }

  return {
    timeStamp: normalizedTimeStamp,
    price: normalizedPrice,
  };
}

export function getMostRecentMarketEvent({ trade, lastTrade, lastQuote }) {
  const bid = toFiniteNumber(lastQuote?.bid);
  const ask = toFiniteNumber(lastQuote?.ask);
  const bidTimeStamp = toFiniteNumber(lastQuote?.bidTimeStamp);
  const askTimeStamp = toFiniteNumber(lastQuote?.askTimeStamp);
  const quoteTimeStamp = Math.max(bidTimeStamp ?? -Infinity, askTimeStamp ?? -Infinity);
  const quoteMidPrice =
    bid !== null && ask !== null && bid > 0 && ask > 0 ? (bid + ask) / 2 : null;

  const candidates = [
    buildCandidate({
      timeStamp: trade?.timeStamp,
      price: trade?.price,
    }),
    buildCandidate({
      timeStamp: lastTrade?.date,
      price: lastTrade?.last,
    }),
    buildCandidate({
      timeStamp: Number.isFinite(quoteTimeStamp) ? quoteTimeStamp : null,
      price: quoteMidPrice,
    }),
  ]
    .filter(Boolean)
    .sort((left, right) => right.timeStamp - left.timeStamp);

  return candidates[0] ?? null;
}
